import { render, staticRenderFns } from "./EquipeSelect.vue?vue&type=template&id=ff61d0b0&"
import script from "./EquipeSelect.vue?vue&type=script&lang=js&"
export * from "./EquipeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports